import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class BackButton extends Component {

    render() {
        const buttonText = this.props.buttonText ? this.props.buttonText : this.props.strings.BACK_BUTTON_TEXT
        return (
            <div className="back-button py-3">
                <Link to={this.props.target}>
                    <h6 className="my-0"><i className="mdi mdi-chevron-left back-button-icon" />{buttonText}</h6>
                </Link>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        language: state.language.language,
        strings: state.language.strings,
        // default to homepage (app)
        target: ownProps.target ? ownProps.target : "app",
    }
};

const ConnectedBackButton = connect(
    mapStateToProps,
)(BackButton);
export default ConnectedBackButton;
